const reasons = [
  {
    icon: 'ri-building-2-line',
    title: 'Meaningful Work',
    description:
      'Build and renovate apartment communities and healthcare facilities that improve people\'s lives across the Mid-Atlantic and Southeast.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Growth Opportunity',
    description:
      'Join a company that is actively expanding into new markets and new states. Your career grows as we grow.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Respect and Safety',
    description:
      'We maintain a zero-incident safety culture and treat every team member, subcontractor, and trade partner with professionalism and respect.',
  },
];

export default function WhyWorkHere() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2B2B2B] mb-12 text-center">
          Why Work at Deer Point
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason) => (
            <div
              key={reason.title}
              className="bg-gray-50 rounded-lg p-8 flex flex-col items-start border border-gray-100 hover:shadow-md transition-shadow duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-5">
                <i className={`${reason.icon} text-[#C5A55A] text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#2B2B2B] mb-3">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
